import slugify from './slugify';
import deconstructLocation from './deconstructLocation';
import appendUTMParams from './utmParams';

const locationUrl = ({ breadcrumbs, state, suburb, suburbUrl }) => {
  let url = [];
  if (breadcrumbs && !!breadcrumbs.length) {
    url = breadcrumbs.reduce(
      (aggregate, { url_slug: urlSlug, breadcrumb }, index) => {
        if (
          aggregate.length &&
          aggregate[aggregate.length - 1] === `/${urlSlug}`
        )
          return aggregate;
        return aggregate.concat(`/${slugify(breadcrumb)}`);
      },
      []
    );

    return appendUTMParams(url.join(''));
  }
  if (state || suburb) {
    let suburbParts = {};
    if (suburbUrl) {
      suburbParts = deconstructLocation(suburbUrl);
    }
    if (state) {
      url.push(`/${slugify(state)}`);
    }
    if (suburb) {
      if (suburbParts && suburbParts.postcode) {
        url.push(slugify(`${suburb} ${suburbParts.postcode}`));
      } else {
        url.push(slugify(suburb));
      }
    }

    return appendUTMParams(url.join('/'));
  }

  return null;
};

export default locationUrl;
